import { Input, Table, Tabs, DatePicker, Button, Select } from "antd";
import { Tooltip as Tip } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
    faFileCircleQuestion,
    faFileCircleCheck,
    faFileArrowDown,
    faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    API_HEADER,
    getDashboardData,
    getCountryList,
    clients_allprojects_data_url,
    get_program_url,
    get_scope_url
} from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import LegendTable from "../LegendTable";
import ProjectNameWithDelay from "../ProjectNameWithDelay";

const { Option } = Select;

const CDash = () => {

    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");
    const [pendingDocs, setPendingDocs] = useState(0);
    const [underLODReview, setUnderLODReview] = useState(0);
    const [underDeskReview, setUnderDeskReview] = useState(0);
    const [siteVisitCompleted, setSiteVisitCompleted] = useState(0);
    const [siteVisitFinding, setSiteVisitFinding] = useState(0);
    const [underDVR, setUnderDVR] = useState(0)
    const [technicalReview, setTechnicalReview] = useState(0)
    const [ccReview, setCCReview] = useState(0)
    const [RFI, setRFI] = useState(0)
    const [RFICompleted, setRFICompleted] = useState(0)
    const [kickout, setKickout] = useState(0)
    const [issuedRegisters, setIssuedRegisters] = useState(0);
    const [activeKey, setActiveKey] = useState("1");
    const [statuskey, setStatus] = useState(1);
    const [dvrStatus, setDVRStatus] = useState('');
    const [clientPendingDoc, setClientPendingDoc] = useState(0)
    const [earthoodPendingDoc, setEarthoodPendingDoc] = useState(0);
    const [totalProject, setTotalProject] = useState(0)
    const [alldata, setAlldata] = useState([]);
    let [loader, Setloader] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const getDashData = async () => {
        try {
            const result = await axios.get(`${getDashboardData}`, API_HEADER);
            const dashboard = result.data.dashboard;

            setPendingDocs(dashboard.status1);
            setUnderLODReview(dashboard.status2);
            setUnderDeskReview(dashboard.status3);
            setSiteVisitCompleted(dashboard.status4);
            setSiteVisitFinding(dashboard.status5);
            setUnderDVR(dashboard.status6)
            setTechnicalReview(dashboard.status7)
            setCCReview(dashboard.status8)
            setRFI(dashboard.status9)
            setRFICompleted(dashboard.status10)
            setKickout(dashboard.status11)
            setIssuedRegisters(dashboard.status12)
            setClientPendingDoc(dashboard.pending_at_client)
            setEarthoodPendingDoc(dashboard.pending_at_earthood)
            setTotalProject(dashboard.total_project)

        } catch (error) {
        }
    };

    useEffect(() => {
        getDashData();
    }, []);

    const allData = async () => {
        try {
            let payload = {
                project_status: statuskey,
                page: pagination.current,
                limit: pagination.pageSize,
                fromDate: fromDate ? fromDate.format("YYYY-MM-DD") : null,
                toDate: toDate ? toDate.format("YYYY-MM-DD") : null,
                country: country ? country : null,
                program: program ? program : null,
                scope: scope ? scope : null,
                search: search ? search : null,
                dvr_status: dvrStatus
            };
            const response = await axios.post(
                `${clients_allprojects_data_url}`,
                payload,
                API_HEADER
            );
            setAlldata(response.data.records.data);

            setPagination((prevPagination) => ({
                ...prevPagination,
                total: response.data.records.total,
            }));

            Setloader(false);
        } catch (error) {
            toast.error(error.response.data.message);
        }
    };

    const handleTabChange = (key) => {
        setFromDate(null);
        setToDate(null);
        setCountry(null);
        setProgram(null);
        setScope(null);
        setSearch(null);

        setActiveKey(key);

        setPagination((prevPagination) => ({
            ...prevPagination,
            current: 1,
        }));

        setDVRStatus('')

        if (key == 1) {
            setStatus(1);

        } else if (key == 2) {
            setStatus(2);

        } else if (key == 3) {
            setStatus(3);
        }
        else if (key == 4) {
            setStatus(4);
        }
        else if (key == 5) {
            setStatus(5);

        }
        else if (key == 6) {
            setStatus(6);
        }
        else if (key == 7) {
            setStatus(7);
        }
        else if (key == 8) {
            setStatus(8);
        }
        else if (key == 9) {
            setStatus(9);
        }
        else if (key == 10) {
            setStatus(10);
        }
        else if (key == 11) {
            setStatus(11);
        }
        else if (key == 12) {
            setStatus(12);
        }


        Setloader(true);
    };

    useEffect(() => {
        allData();
    }, [loader]);

    const handleTableChange = (pagination, filters, sorter) => {
        setPagination(pagination);
        Setloader(true);
    };

    const dateFormat = "DD/MM/YYYY";
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [country, setCountry] = useState(null);
    const [program, setProgram] = useState(null);
    const [search, setSearch] = useState(null);

    const handleSearch = (value) => {
        setSearch(value);
        Setloader(true);
    };


    const handleFromDateChange = (date) => {
        setFromDate(date);
        Setloader(true);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
        Setloader(true);
    };
    const disabledFutureDate = (current) => {
        return current && current > moment().endOf('day');
    };

    const handleSearchByDateRange = (value) => {
        const currentDate = moment();
        if (fromDate && fromDate.isAfter(currentDate)) {
            toast.error("From date cannot be a future date");
        } else if (toDate && toDate.isAfter(currentDate)) {
            toast.error("To date cannot be a future date");
        } else if (fromDate && toDate && fromDate.isAfter(toDate)) {
            toast.error("From date cannot be greater than to date");
        } else {
            Setloader(true);
        }
    };
    const handleProgramNameSearch = (value) => {
        setProgram(value);
        Setloader(true);
    };

    const handleCountrySearch = (value) => {
        setCountry(value);
        Setloader(true);
    };
    const handleScopeSearch = (value) => {
        setScope(value);
        Setloader(true);
    };

    const handleSearchAll = (value) => {
        setSearch(value);
        Setloader(true);
    };

    const [scope, setScope] = useState(null);
    const [countryList, setCountryList] = useState([]);
    const [scopeList, setScopeList] = useState([]);
    const [programname, setProgramname] = useState([]);

    const getCountry = async () => {
        try {
            const result = await axios.get(`${getCountryList}`);
            setCountryList(result.data.data);
        } catch (error) {
        }
    };
    const getProgramname = async () => {
        try {
            const result = await axios.get(`${get_program_url}`);
            setProgramname(result.data.data);
        } catch (error) {
        }
    };
    const getScope = async () => {
        try {
            const result = await axios.get(`${get_scope_url}`);
            setScopeList(result.data.data);
        } catch (error) {
        }
    };
    const filterOption = (input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

    useEffect(() => {
        getCountry();
        getProgramname();
        getScope();
    }, []);

    const handleClientAction = async (id) => {
        navigate(`/clientprojectdetails/${id}`);
    };
    const editFormForDeskReview = async (id) => {
        navigate(`/clientprojectdetails/${id}`)

    }

    const editFormForKickOut = async (id) => {
        navigate(`/kickoutmodule/${id}`)
      }

      
    const columnPendingDocs = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",
            fixed: "left",
            width: 60,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Received Date
                </span>
            ),
            width: 100,

            render: (text, record) => (
                <span className="text-capitalize font14px">{record.created_at.slice(8, 10)}-{record.created_at.slice(5, 7)}-{record.created_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {

                return (record1.created_at.slice(0, 10) > record2.created_at.slice(0, 10)) ? 1 : (record1.created_at.slice(0, 10) === record2.created_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
              <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                {record.earthood_id}
              </span>
            </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolor">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>
            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 100,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.scope_name?.scope}</span>
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 60,
            render: (record) => (
                <a className="">
                    <EditOutlined
                        onClick={() => handleClientAction(record.id)}
                        style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                    />
                </a>
            ),
        },
    ];

    const columnUnderLODReview = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",
            fixed: "left",
            width: 60,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Submission Date
                </span>
            ),
            width: 100,

            render: (text, record) => (
                <span className="text-capitalize font14px">{record.created_at.slice(8, 10)}-{record.created_at.slice(5, 7)}-{record.created_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.created_at.slice(0, 10) > record2.created_at.slice(0, 10)) ? 1 : (record1.created_at.slice(0, 10) === record2.created_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // sorter: (record1, record2) => {
            //     return record1.earthood_id.localeCompare(record2.earthood_id);
            // }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Status
                </span>
            ),
            width: 130,

            render: (text, record) => {
                let color = "red";
                let msg = "";
                if (record.status == 1) {
                    msg = "Contract Signed";
                    color = "orange";
                } else if (record.status == 2 || record.status == 6) {
                    msg = "Client Submitted Document";
                    color = "black";
                } else if (record.status == 3 || record.status == 5) {
                    msg = "TL Approval Pending";
                } else if (record.status == 4) {
                    msg = "Action Pending";
                    color = "black";
                } else if (record.status == 7) {
                    msg = "Finding Pending";
                } else {
                    msg = record.status;
                }

                return (
                    <Tip title={msg}>
                <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                  {msg}
                </span>
              </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.status > record2.status) ? 1 : (record1.status === record2.status) ? 0 : -1
            }

        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 70,
            render: (record) => (
                <a className="">
                    {record.status === 4 ? (
                        <EditOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    ) : (
                        <EyeOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    )}
                </a>
            ),
        },
    ];

    const columnUnderDeskReview = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 60,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 100,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 100,

            render: (text, record) => (
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Status
                </span>
            ),

            width: 120,


            render: (text, record) => {
                let color = "black";
                let msg = "";
                if (record.finding_status == 0 || record.finding_status == null) {
                    msg = "LOD Completed";
                }
                else if (record.finding_status == 1) {
                    msg = "Submitted to TL";
                } else if (record.finding_status == 2) {
                    msg = "TL reverted to Team";
                } else if (record.finding_status == 3) {
                    msg = "TL reverted to Team";
                } else if (record.finding_status == 4) {
                    msg = "Action Pending";
                } else if (record.finding_status == 5) {
                    msg = "Client Responded";
                } else if (record.finding_status == 6) {
                    msg = "Finding Closed";
                }
                else {
                    msg = record.finding_status;
                }

                return (
                    <Tip title={msg}>
                    <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                      {msg}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.finding_status > record2.finding_status) ? 1 : (record1.finding_status === record2.finding_status) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 90,
            render: (record) => (


                <a className="">
                    {record.finding_status === 4 ? (
                        <EditOutlined
                            onClick={() => editFormForDeskReview(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    ) : (
                        <EyeOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    )}
                </a>
            ),
        },
    ];


    const columnSiteVisitCompleted = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 60,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.scope_name?.scope}</span>
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.program_name?.description}
                    </span>
                  </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 80,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.country_name?.description}
                    </span>
                  </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">

                    <EyeOutlined
                        onClick={() => handleClientAction(record.id)}
                        style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                    />

                </a>
            ),
        },
    ];

    const columnSiteVisitFinding = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.scope_name?.scope}</span>
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
                
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 100,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Site Finding Status
                </span>
            ),
            width: 160,
            render: (text, record) => {
                let color = "red";
                let msg = "";
                if (record.site_finding_status == 0 || record.site_finding_status == null) {
                    msg = "Site Visit Completed";
                    color = "red";
                }
                else if (record.site_finding_status == 1) {
                    msg = "Submitted to TL";
                    color = "orange";
                } else if (record.site_finding_status == 2) {
                    msg = "TL reverted to Team";
                    color = "black";
                } else if (record.site_finding_status == 3) {
                    msg = "TL reverted to Team";
                    color = "black";
                } else if (record.site_finding_status == 4) {
                    msg = "Action Pending";
                    color = "black";
                } else if (record.site_finding_status == 5) {
                    msg = "Client Responded";
                    color = "green";
                } else if (record.site_finding_status == 6) {
                    msg = "Site Finding Closed";
                    color = "brown";
                }
                else {
                    msg = record.site_finding_status;
                }

                return (
                    <Tip title={msg}>
                    <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                      {msg}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.site_finding_status > record2.site_finding_status) ? 1 : (record1.site_finding_status === record2.site_finding_status) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">
                    {record.site_finding_status === 4 ? (
                        <EditOutlined
                            onClick={() => editFormForDeskReview(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    ) : (
                        <EyeOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    )}
                </a>
            ),
        },
    ];

    const columnUnderDVR = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 150,

            render: (text, record) => (
                <ProjectNameWithDelay record={record}/>
            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.scope_name?.scope}</span>
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
                

            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold d-block text-center">
                    Status
                </span>
            ),
            width: 140,
            render: (text, record) => {
                let color = "red";
                let msg = "";
                if (record.tr_status == 1) {
                    msg = "Finding  Closed";
                    color = "red";
                }
                else if (record.tr_status == 2) {
                    msg = "Sent To Tr";
                    color = "orange";
                } else if (record.tr_status == 3) {
                    msg = "Tr Raised Clarification";
                    color = "black";
                } else if (record.tr_status == 4) {
                    msg = "Action Pending";
                    color = "blue";
                }
                else if (record.tr_status == 5) {
                    msg = "Client Resubmitted";
                    color = "brown";
                }
                else if (record.tr_status == 6) {
                    msg = "Approved";
                    color = 'green'
                } else {
                    msg = record.tr_status;
                }

                return (
                    <Tip title={msg}>
                <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                  {msg}
                </span>
              </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.tr_status > record2.tr_status) ? 1 : (record1.tr_status === record2.tr_status) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">
                    {record.tr_status === 4 ? (
                        <EditOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    ) : (
                        <EyeOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    )}
                </a>
            ),
        },
    ];

    const columnTechnicalReview = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Finding  Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.scope_name?.scope}</span>
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.country_name?.description}
                    </span>
                  </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold  d-block text-center">
                    Status
                </span>
            ),
            width: 140,
            render: (text, record) => {
                let color = "red";
                let msg = "";
                // if (record.tr_status == 1) {
                //     msg = "DVR Prepared";
                //     color = "red";
                // }
                // else if (record.tr_status == 2) {
                //     msg = "Sent To Tr";
                //     color = "orange";
                // } else if (record.tr_status == 3) {
                //     msg = "Tr Raised Clarification";
                //     color = "black";
                // } else if (record.tr_status == 4) {
                //     msg = "Action Pending";
                //     color = "blue";
                // }
                // else if (record.tr_status == 5) {
                //     msg = "Client Resubmitted";
                //     color = "brown";
                // }
                // else if (record.tr_status == 6) {
                //     msg = "Approved";
                //     color = 'green'
                // } else {
                //     msg = record.tr_status;
                // }

                if (record.tr_status == 1) {
                    msg = "Sent to TR";
                    color = "brown";
                }
                else if (record.tr_status == 2) {
                    msg = "Sent To Team Member";
                    color = "orange";
                } else if (record.tr_status == 3) {
                    msg = "Team sent to TL";
                    color = "black";
                } else if (record.tr_status == 4) {
                    msg = "Action Pending";
                    color = "blue";
                }
                else if (record.tr_status == 5) {
                    msg = "Client Resubmitted";
                    color = "brown";
                }
                else if (record.tr_status == 6) {
                    msg = "Sent to TR";
                    color = 'black'
                } else if (record.tr_status == 7) {
                    msg = "TR raised clarification";
                    color = 'black'
                } else if (record.tr_status == 8) {
                    msg = "TR approved";
                    color = 'green'
                }
                else {
                    msg = record.tr_status;
                }


                return (
                    <Tip title={msg}>
                <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                  {msg}
                </span>
              </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.tr_status > record2.tr_status) ? 1 : (record1.tr_status === record2.tr_status) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">
                    {record.tr_status === 4 ? (
                        <EditOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    ) : (
                        <EyeOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    )}
                </a>
            ),
        },
    ];

    const columnCCReview = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 140,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 140,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.country_name?.description}
                    </span>
                  </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold d-block text-center">
                    Status
                </span>
            ),
            width: 140,
            render: (text, record) => {
                let color = "red";
                let msg = "";
                if (record.cc_status == 0) {
                    msg = "TR Completed";
                    // color = "red";
                    color = '#153448'
                }
                else if (record.cc_status == 1) {
                    msg = "Team allocated the CC";
                    color = "orange";
                } else if (record.cc_status == 2) {
                    msg = "CC raised clarification";
                    color = "blue";
                } else if (record.cc_status == 3) {
                    msg = "TL sent to team";
                    color = 'black'
                } else if (record.cc_status == 4) {
                    msg = "Sent to client";
                    color = 'purple'
                }
                else if (record.cc_status == 5) {
                    msg = "Client resubmitted";
                    color = 'purple'
                }
                else if (record.cc_status == 6) {
                    msg = "Member sent to TL";
                    color = 'brown'
                }
                else if (record.cc_status == 7) {
                    msg = "Sent to CC";
                    color = 'green'
                }
                else if (record.cc_status == 8) {
                    msg = "Sent to TR";
                    color = 'green'
                }
                else if (record.cc_status == 9) {
                    msg = "TR raised clarification ";
                    color = 'green'
                }
                else if (record.cc_status == 10) {
                    msg = "TR approved";
                    color = 'green'
                }
                else if (record.cc_status == 11) {
                    msg = "CC approved";
                    color = 'green'
                }
                else {
                    msg = record.cc_status;
                }

                return (
                    <Tip title={msg}>
                <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                  {msg}
                </span>
              </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.cc_status > record2.cc_status) ? 1 : (record1.cc_status === record2.cc_status) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">
                    {record.cc_status === 4 ? (
                        <EditOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    ) : (
                        <EyeOutlined
                            onClick={() => handleClientAction(record.id)}
                            style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                        />
                    )}
                </a>
            ),
        },
    ];

    const columnRFI = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 150,

            render: (text, record) => (
                <ProjectNameWithDelay record={record}/>
            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
                
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
                
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">

                    <EyeOutlined
                        onClick={() => handleClientAction(record.id)}
                        style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                    />

                </a>
            ),
        },
    ];

    const columnRFICompleted = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                    
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 150,

            render: (text, record) => (
                <ProjectNameWithDelay record={record}/>
            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.program_name?.description}
                    </span>
                  </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.country_name?.description}
                    </span>
                  </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">

                    <EyeOutlined
                        onClick={() => handleClientAction(record.id)}
                        style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                    />

                </a>
            ),
        },
    ];

    const columnKickout = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 130,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 150,

            render: (text, record) => (
                <ProjectNameWithDelay record={record}/>
            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>
                
            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold d-block text-center">
                    Status
                </span>
            ),
            width: 140,
            render: (text, record) => {
                let color = "red";
                let msg = "";
                if (record.kickout_status == 1) {
                    msg = "Kickout Started";
                    color = 'black'
                }
                else if (record.kickout_status == null || record.kickout_status == 0) {
                    msg = "RFI Completed";
                }
                else if (record.kickout_status == 2) {
                    msg = "AT forwarded to TL";
                }
                else if (record.kickout_status == 3) {
                    msg = "TL sent to team members";
                }
                else if (record.kickout_status == 4) {
                    msg = "Sent to Client";
                }
                else if (record.kickout_status == 5) {
                    msg = "Client Resubmitted";
                }
                else if (record.kickout_status == 6) {
                    msg = "TL sent to TR";
                }
                else if (record.kickout_status == 7) {
                    msg = "TR raised clarification in TR Round";
                }
                else if (record.kickout_status == 8) {
                    msg = "TL Sent to team member in TR Round";
                }
                else if (record.kickout_status == 9) {
                    msg = "Team Member forward to TL in TR Round";
                }
                else if (record.kickout_status == 10) {
                    msg = "TL Sent to Client in TR Round";
                }
                else if (record.kickout_status == 11) {
                    msg = "Client Resubmitted in TR Round";
                }
                else if (record.kickout_status == 12) {
                    msg = "TL resubmitted to TR";
                }
                else if (record.kickout_status == 13) {
                    msg = "TR approved";
                }
                else if (record.kickout_status == 14) {
                    msg = "TL allocated CC Reviewer";
                }
                else if (record.kickout_status == 15) {
                    msg = "CC raised clarification";
                }
                else if (record.kickout_status == 16) {
                    msg = "Team Member sent to TL in CC Round";
                }
                else if (record.kickout_status == 17) {
                    msg = "TL forwarded to team members in CC Round";
                }
                else if (record.kickout_status == 18) {
                    msg = "TL forwarded to client";
                }
                else if (record.kickout_status == 19) {
                    msg = "Client resubmitted in";
                }
                else if (record.kickout_status == 20) {
                    msg = "TL forwarded to TR";
                }
                else if (record.kickout_status == 21) {
                    msg = "TR raised clarification";
                }
                else if (record.kickout_status == 22) {
                    msg = "TR approved";
                }
                else if (record.kickout_status == 23) {
                    msg = "TL to CC Reviewer";
                }
                else if (record.kickout_status == 24) {
                    msg = "CC Approved";
                }
                else if (record.kickout_status == 25) {
                    msg = "Team Member sent to TL";
                }
                else if (record.kickout_status == 26) {
                    msg = "TL sent to Team";
                }

                else if (record.kickout_status == 27) {
                    msg = "TL sent to TM";
                }

                else if (record.kickout_status == 28) {
                    msg = "TM raised clarification";
                }
                else if (record.kickout_status == 29) {
                    msg = "TM approved";
                }
                else if (record.kickout_status == 30) {
                    msg = "MD raised clarification";
                }
                else if (record.kickout_status == 31) {
                    msg = "MD approved";
                }
                else if (record.kickout_status == 32) {
                    msg = " Kickout RFI Completed";
                }

                return (
                    <Tip title={msg}>
                    <span className="text-capitalize font14px preserve-space text-ellipsis" style={{ color }}>
                      {msg}
                    </span>
                  </Tip>
                );
            },

        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            width: 80,
            render: (record) => (


                <a className="">

                            {
                            record.kickout_status == 4 ||  record.kickout_status == 10 || record.kickout_status == 18 ?
                            <EditOutlined
                                style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                                onClick={() => editFormForKickOut(record.id)}
                            />
                            :
                            <EyeOutlined
                                style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                                onClick={() => editFormForKickOut(record.id)}
                            />
                    }
                </a>
            ),
        },
    ];

    const columnInformedRegistery = [
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    S.No
                </span>
            ),
            dataIndex: "id",

            fixed: "left",
            width: 70,
            render: (id, record, index) => {
                const pageIndex = (pagination.current - 1) * pagination.pageSize;
                return pageIndex + index + 1;
            },
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action Date
                </span>
            ),
            width: 120,
            render: (text, record) => (
                <span className="text-capitalize font14px">{record.updated_at.slice(8, 10)}-{record.updated_at.slice(5, 7)}-{record.updated_at.slice(0, 4)}</span>
            ),
            sorter: (record1, record2) => {
                return (record1.updated_at.slice(0, 10) > record2.updated_at.slice(0, 10)) ? 1 : (record1.updated_at.slice(0, 10) === record2.updated_at.slice(0, 10)) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    EID
                </span>
            ),
            width: 140,

            render: (text, record) => {
                return (
                    // <span className="font14px">
                    //     {record.earthood_id}
                    // </span>
                    <Tip title={record.earthood_id}>
                    <span className="text-capitalize textcolorgreen font14px preserve-space text-ellipsis">
                      {record.earthood_id}
                    </span>
                  </Tip>
                    
                );
            },
            sorter: (record1, record2) => {
                return (record1.earthood_id > record2.earthood_id) ? 1 : (record1.earthood_id === record2.earthood_id) ? 0 : -1
            },
            // defaultSortOrder: 'ascend'
        },

        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Project Name
                </span>
            ),
            width: 150,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.project_name}</span>
                <ProjectNameWithDelay record={record}/>

            ),
            sorter: (record1, record2) => {
                return (record1.project_name > record2.project_name) ? 1 : (record1.project_name === record2.project_name) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Scope
                </span>
            ),
            width: 120,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.scope_name?.scope}</span>
                <Tip title={record.scope_name?.scope}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.scope_name?.scope}
                </span>
              </Tip>
            ),
            sorter: (record1, record2) => {
                return (record1.scope_name?.scope > record2.scope_name?.scope) ? 1 : (record1.scope_name?.scope === record2.scope_name?.scope) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Program
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px textcolorgreen">{record.program_name?.description}</span>
                <Tip title={record.program_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.program_name?.description}
                </span>
              </Tip>
                
            ),
            sorter: (record1, record2) => {
                return (record1.program_name?.description > record2.program_name?.description) ? 1 : (record1.program_name?.description === record2.program_name?.description) ? 0 : -1
            }
        },


        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Country
                </span>
            ),
            width: 90,

            render: (text, record) => (
                // <span className="text-capitalize font14px">{record.country_name?.description}</span>
                <Tip title={record.country_name?.description}>
                <span className="text-capitalize font14px preserve-space text-ellipsis">
                  {record.country_name?.description}
                </span>
              </Tip>

            ),
            sorter: (record1, record2) => {
                return (record1.country_name?.description > record2.country_name?.description) ? 1 : (record1.country_name?.description === record2.country_name?.description) ? 0 : -1
            }
        },
        {
            title: (
                <span className="text-capitalize textcolumntitle font14px fw-bold">
                    Action
                </span>
            ),
            dataIndex: "",
            key: "x",
            fixed: "right",
            width: 80,
            render: (record) => (


                <a className="">

                    <EyeOutlined
                        onClick={() => handleClientAction(record.id)}
                        style={{ marginRight: "8px", color: "blue", fontSize: '20px' }}
                    />

                </a>
            ),
        },
    ];


    const handleTotalProject = () => {
        navigate('/totalprojects')
    }
    const handleClientEndPending = () => {
        navigate('/totalprojects', { state: { id: 1 } })
    }
    const handleEarthoodEndPending = () => {
        navigate('/totalprojects', { state: { id: 2 } })
    }

    return (
        <>
            <div>
                <div>
                    <span>Total Projects: <b onClick={handleTotalProject} style={{ cursor: 'pointer', color: 'blue' }}> {totalProject}</b> </span><br />
                    <span>Projects pending at Client's end: <b onClick={handleClientEndPending} style={{ cursor: 'pointer', color: 'blue' }} >{clientPendingDoc}</b></span><br />
                    <span>Projects pending at Earthood's end: <b onClick={handleEarthoodEndPending} style={{ cursor: 'pointer', color: 'blue' }}>{earthoodPendingDoc}</b></span><br />
                </div>
            </div>
            <div className="container-fluid bg-white">
                <div className="row">
                    <div className="col-12">
                        <Tabs
                            defaultActiveKey="1"
                            centered
                            activeKey={activeKey}
                            onChange={handleTabChange}
                            className="client_dash_tab_align"
                        >                
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 1 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Pending docs submission
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {pendingDocs}
                                            </p>
                                            <FontAwesomeIcon
                                                icon={faFileArrowDown}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="1"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Pending docs submission
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row align-items-center d-flex p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className=" px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />                          </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{
                                                    x: 1000,
                                                }}
                                                columns={columnPendingDocs}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 2 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Ongoing Documentation
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {underLODReview}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleQuestion}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="2"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Ongoing Documentation
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        />
                                                        </div>

                                                </div>
                                            </div>
                                            <Table
                                                scroll={{
                                                    x: 1000,
                                                }}
                                                columns={columnUnderLODReview}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                           
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 3 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Under Desk Review
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {underDeskReview}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="3"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Under Desk Review
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnUnderDeskReview}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                            {/* <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 4 ? 'box_tab' : ''}`}>
                                        <div className="d-flex justify-content-between align-items-center ">
                                            <p className="textcolorblue stat_text">
                                                {siteVisitCompleted}
                                            </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="2xl"
                                                className="iconcolor"
                                            />
                                        </div>

                                        <p className="font14px textlightblack text-capitalize mt-lg-2 mt-md-2 mt-sm-2 mt-2 text-wrap">
                                            Site Visit Completed
                                        </p>

                                    </div>
                                }
                                key="4"
                            > */}
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 4 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Site Visit Completed
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {siteVisitCompleted}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="4"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Site Visit Completed
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnSiteVisitCompleted}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>


                         
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 5 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Site Visit Findings
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {siteVisitFinding}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="5"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Site Visit Findings
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnSiteVisitFinding}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                           
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 6 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Under DVR
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {underDVR}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="6"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Under DVR
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnUnderDVR}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                           
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 7 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Tech. Review
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {technicalReview}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="7"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Tech. Review
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnTechnicalReview}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                           
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 8 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        CC Review
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {ccReview}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="8"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            CC Review
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnCCReview}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                           
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 9 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        RFI
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {RFI}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="9"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            RFI
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnRFI}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                         
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 10 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        RFI Completed
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {RFICompleted}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="10"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            RFI Completed
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnRFICompleted}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 11 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Kickout
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {kickout}
                                        </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="11"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            Kickout
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnKickout}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>


                          
                            <Tabs.TabPane
                                tab={
                                    <div className={`border-1 borderlightgreen rounded-2 p-2 mx-0 tabactivecolor  tab_dashboard_size5tab ${activeKey == 12 ? 'box_tab' : ''}`}>
                                        <p className="font14px textlightblack text-capitalize text-wrap">
                                        Issued/Registered
                                        </p>                                          
                                      <div className="paracenter">                                   
                                        <p className="textcolorblue stat_text">
                                        {issuedRegisters}
                                            </p>
                                            <FontAwesomeIcon
                                                icon={faFileCircleCheck}
                                                size="xl"
                                                className="iconcolor"
                                            />
                                        </div>
                                    </div>
                                }
                                key="12"
                            >
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 border-1 border border-light-subtle p-0 rounded-3">
                                            <div className="bg-white border-0 shadow-sm rounded-top-3">
                                                <div className="row border-0">
                                                    <div className="col-12">
                                                    <p className="text-black text-capitalize  font20px fw-medium p-2 rounded-top-3">
                                                            informed Registry
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3 align-items-center p-2">
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="d-grid mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Scope{" "}
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select scope"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleScopeSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>

                                                                {scopeList.map((scope, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={scope.id}
                                                                        label={scope.sector_name}
                                                                    >
                                                                        {scope.sector_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Program Name
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select program name"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleProgramNameSearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {programname.map((program, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={program.id}
                                                                        label={program.program_name}
                                                                    >
                                                                        {program.program_name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                Country
                                                            </label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select country"
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                onChange={handleCountrySearch}
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                            >
                                                                <Option value="">Select</Option>
                                                                {countryList.map((country, index) => (
                                                                    <Option
                                                                        key={index}
                                                                        value={country.id}
                                                                        label={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                        </div>

                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                From Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleFromDateChange}
                                                                placeholder="From Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <div className="mb-3">
                                                            <label className="text-capitalize textcolumntitle font16px  fw-bold font12px">
                                                                To Recd. Date
                                                            </label>
                                                            <DatePicker
                                                                onChange={handleToDateChange}
                                                                placeholder="To Date"
                                                                style={{ width: "100%",  }}
                                                                className="rounded-2"
                                                                format={dateFormat}
                                                                showTime={false}
                                                                disabledDate={disabledFutureDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-md-3">
                                                        <Button
                                                            className="py-1 px-2 mt-3 btn btn-success btn-sm rounded-2"
                                                            onClick={handleSearchByDateRange}
                                                        >
                                                            Search
                                                        </Button>
                                                    </div>

                                                    <div className="col-sm-4 col-md-3 mt-3">
                                                        <Input.Search
                                                            allowClear
                                                            placeholder="Search By Project Name/EID"
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            value={searchValue}
                                                            enterButton
                                                            onSearch={handleSearch}
                                                            style={{ width: "100%",  }}
                                                            className="rounded-2 custom-search"
                                                        // buttonStyle={{ backgroundColor: '#fff' }} // Change color here
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <Table
                                                scroll={{ x: 1000 }}
                                                columns={columnInformedRegistery}
                                                loading={loader}
                                                dataSource={alldata}
                                                rowKey="id"
                                                pagination={pagination}
                                                onChange={handleTableChange}
                                                bordered
                                            />
                                            {
                                                alldata != '' ?
                                                    (<>
                                                        <LegendTable />
                                                    </>) : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tabs.TabPane>

                        </Tabs>
                    </div>
                </div>
            </div>


        </>
    )
}

export default CDash